export default __webpack_public_path__ + "static/media/Anant-Aman_Logo-1 1.9c646397.png";